import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { apiGet } from "../api/client";

interface ChainNode {
  id: string;
  version_no: number;
  issued_at: string | null;
  effective_at: string | null;
  status: string;
  checksum: string;
  summary: string;
}

export default function TracingPath() {
  const { id } = useParams();
  const [chain, setChain] = useState<ChainNode[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    apiGet<any>(`/regulations/${id}/trace`)
      .then((data) => {
        const nodes: ChainNode[] = (data.chain || [])
          .map((cid: string) => {
            // simulate fetch — in real app, map to full node
            return { id: cid, version_no: Number(cid.split("-v")[1]), issued_at: null, effective_at: null, status: "aktif", checksum: "•••", summary: "ringkas" };
          });
        setChain(nodes);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading || !id) {
    return (
      <div className="mt-4 space-y-2">
        {Array.from({ length: 5 }, (_, i) => (
          <div key={i} className="h-10 animate-pulse rounded border border-border" />
        ))}
      </div>
    );
  }

  return (
    <div>
      <Link to={`/regulations/${id}`} className="text-sm text-muted hover:text-text mb-3 inline-block">
        ← Kembali ke {id}
      </Link>

      <h2 className="text-2xl font-bold text-text">Tracing Path — {id}</h2>
      <p className="text-sm text-muted mb-4">
        Jalur {chain.length} versi yang saling terkait (amandemen → pengesahan ulang → klarifikasi).
      </p>

      <div className="relative ml-4 border-l-2 border-aspace pl-4">
        {chain.map((node, idx) => (
          <div key={node.id} className="relative mb-3">
            <div
              className={`absolute -start-1.5 top-1.5 h-3 w-3 rounded-full border-2 ${
                idx === 0 ? "bg-primary" : "bg-aspace"
              }`}
            />
            <div className="flex items-center gap-3 rounded border border-border p-3">
              <span className="font-mono text-xs text-muted">v{node.version_no}</span>
              <span className="text-xs text-muted">{node.issued_at || "—"}</span>
              <span className="rounded-full bg-surface border border-border px-2 py-0.5 text-[11px] font-semibold text-muted">
                {node.status}
              </span>
            </div>
            {idx < chain.length - 1 && (
              <div className="absolute left-2.5 top-5 h-full w-0.5 bg-aspace" />
            )}
          </div>
        ))}
      </div>

      <div className="mt-6 flex flex-wrap gap-3 text-xs text-muted">
        <span className="rounded bg-surface border border-border px-2.5 py-1.5">
          <span className="font-semibold text-text">Teknis:</span> chain akurat, syntaktis
        </span>
        <span className="rounded bg-surface border border-border px-2.5 py-1.5">
          <span className="font-semibold text-text">QC:</span> hukum|IT|visual
        </span>
      </div>
    </div>
  );
}
